<template>
  <div>
    <div :class="$style.title">
      {{name}}
      <div :class="$style.back" v-if="type === 1 ? true : false" @click="backTo">
        <img :src="back" alt />
      </div>
    </div>
  </div>
</template>

<script>
import { CDN_URL } from '@/config';

export default {
  props: {
    name: {
      type: String,
      default: '',
    },
    // type: 1.默认带返回按钮 2.默认不带返回按钮
    type: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      back: `${CDN_URL}/back.png`,
    };
  },
  methods: {
    backTo() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" module>
.title {
  width: 100%;
  height: 45px;
  // background-color: pink;
  text-align: center;
  line-height: 45px;
  font-size: 18px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  position: relative;
  .back {
    width: 45px;
    height: 45px;
    // background-color: yellow;
    position: absolute;
    left: 0;
    top: 0;
    > img {
      width: 20px;
      position: absolute;
      left: 10px;
      top: 12px;
    }
  }
}
</style>